import Vue from 'vue';
import Vuex from 'vuex';

import createPersistedState from 'vuex-persistedstate';
import createPlugin from 'logrocket-vuex';
import LogRocket from 'logrocket';
const logrocketPlugin = createPlugin(LogRocket);

import orders from './modules/orders';
import register from './modules/register';
import impersonate from './modules/impersonate';
import layout from './modules/layout';
Vue.use(Vuex);
const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  strict: debug,
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
    }),
    logrocketPlugin,
  ],
  modules: {
    orders,
    register,
    impersonate,
    layout,
  },
});
